import React, { useContext, useEffect } from 'react';

import { Context } from '../context/contextApi';
import Sidebar from './Sidebar';
import VideoCard from './VideoCard';

const Feed = () => {
	const { loading, searchResults } = useContext(Context);
	useEffect(() => {
		document.getElementById('root').classList.remove('custom-h');
	}, []);
	return (
		<div className="flex h-[calc(100%-56px)] text-white">
			<Sidebar />
			<div className="grow w-[calc(100%-240px)] h-full overflow-y-auto bg-black">
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-5">
					{!loading &&
						searchResults.map((item, i) => {
							if (item?.type !== 'video') return false;
							return (
								<VideoCard key={item?.video?.videoId + i} video={item?.video} />
							);
						})}
				</div>
			</div>
		</div>
	);
};

export default Feed;
